<template>
    <!--
        Widget component.
        Displays content inside a layer above the page content.
        Closable by clicking button CANCEL or by finishing the process
    -->
    <div class="widget modal" :class="{ 'hide': hide }">
        <transition name="fade">
            <div class="modal-background" @click.stop="dismiss" v-if="show"></div>
        </transition>

        <!-- Always activate after transition, to prevent bugs when calling confirm dialog -->
        <transition name="slide-top" @after-leave="activate">
            <component :is="content" v-if="show" :args="args" />
        </transition>
    </div>
</template>

<script>
import events from '../../events/events';
import { loadComponent } from '../../services';

export default
{
    name: 'Widget',

    data() {
        return {
            show: false,
            content: '',
            args: null,
            properties: null,
            hide: false,
            dismissable: false,
        }
    },

    created()
    {
        /**
         * Open widget dialog.
         *
         * @param {String} content
         * @param {Object} args
         */
        events.$on('widget.open', (content, args, dismissable) => {
            this.args = args;
            this.content = content;
            this.dismissable = dismissable;

            this.show = true;
        });


        /**
         * Close widget
         */
        events.$on('widget.close', this.close);

        /**
         * Reactivate widget
         */
        events.$on('widget.activate', this.activate);

        /**
         * Deactivate widget
         */
        events.$on('widget.deactivate', this.deactivate);
    },

    methods:
    {
        /**
         * Close dialog and remove event listener from window
         */
        close(state)
        {
            this.show = false;
            this.headline = '';
            this.content = '';
            this.args = null;
        },

        /**
         * Hide widget. Widget does not get removed from dom
         */
        deactivate()
        {
            this.hide = true;
        },

        /**
         * Show widget.
         */
        activate()
        {
            this.hide = false;
        },

        /**
         * Dismiss (hide by clicking on modal background)
         */
        dismiss()
        {
        	if (this.dismissable) this.close();
        }
    },

    components:
    {
        /*
         * Application Widgets
         */
        addContract: loadComponent('./components/widgets/addContract'),
        addHours: loadComponent('./components/widgets/addHours'),
        assignLocations: loadComponent('./components/widgets/assignLocations'),
        changeEmail: loadComponent('./components/widgets/changeEmail'),
        changePassword: loadComponent('./components/widgets/changePassword'),
        chatParticipants: loadComponent('./components/widgets/chatParticipants'),
        checkin: loadComponent('./components/widgets/checkin'),
        checkins: loadComponent('./components/widgets/checkins'),
        clients: loadComponent('./components/widgets/clients'),
        contracts: loadComponent('./components/widgets/contracts'),
        contractTemplate: loadComponent('./components/widgets/contractTemplate'),
        costs: loadComponent('./components/widgets/costs'),
        defaultAvailability: loadComponent('./components/widgets/defaultAvailability'),
        denyHours: loadComponent('./components/widgets/denyHours'),
        duties: loadComponent('./components/widgets/duties'),
        employeeNumber: loadComponent('./components/widgets/employeeNumber'),
        employees: loadComponent('./components/widgets/employees'),
        employeesEdit: loadComponent('./components/widgets/employeesEdit'),
        expenses: loadComponent('./components/widgets/expenses'),
        holidays: loadComponent('./components/widgets/holidays'),
        launchDashboard: loadComponent('./components/widgets/launchDashboard'),
        location: loadComponent('./components/widgets/location'),
        locations: loadComponent('./components/widgets/locations'),
        newChat: loadComponent('./components/widgets/newChat'),
        planningMemberships: loadComponent('./components/widgets/planningMemberships'),
        plannings: loadComponent('./components/widgets/plannings'),
        premiums: loadComponent('./components/widgets/premiums'),
        profileLocations: loadComponent('./components/widgets/profileLocations'),
        rates: loadComponent('./components/widgets/rates'),
        report: loadComponent('./components/widgets/report'),
        revenues: loadComponent('./components/widgets/revenues'),
        salary: loadComponent('./components/widgets/salary'),
        shifts: loadComponent('./components/widgets/shifts'),
        switcher: loadComponent('./components/widgets/switcher'),
        tags: loadComponent('./components/widgets/tags'),
        timechooser: loadComponent('./components/widgets/timechooser'),
        userProfile: loadComponent('./components/widgets/userProfile'),
        resources: loadComponent('./components/widgets/resources'),
        signature: loadComponent('./components/widgets/signature'),
        planningResources: loadComponent('./components/widgets/planningResources'),
    }
}
</script>



// WEBPACK FOOTER //
// Widget.vue?5e3bedab